import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // Supported languages
    supportedLngs: ["en", "fr"],

    // Fallback language (French is the primary language)
    fallbackLng: "fr",

    // Default namespace
    defaultNS: "translation",
    ns: ["translation"],

    // Language detection configuration
    detection: {
      // Detection order: URL path → localStorage → browser navigator
      order: ["path", "localStorage", "navigator"],

      // Cache the detected language in localStorage
      caches: ["localStorage"],

      // Key used in localStorage
      lookupLocalStorage: "katalog-language",

      // Look for language in the first segment of the URL path
      lookupFromPathIndex: 0,
    },

    // Backend configuration: load translation JSON files
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },

    // Interpolation settings
    interpolation: {
      // React already handles escaping, so we don't need i18next to do it
      escapeValue: false,
    },

    // React-specific settings
    react: {
      // Use Suspense for loading translations
      useSuspense: true,
    },

    // Do not load translations on init if using Suspense
    // (they will be loaded on demand)
    partialBundledLanguages: true,

    // Debug mode (disable in production)
    debug: import.meta.env.DEV,

    // Return empty string for missing keys in production,
    // return key in development for easier debugging
    returnNull: false,
    returnEmptyString: false,

    // Key separator for nested keys (e.g., "nav.home")
    keySeparator: ".",

    // Namespace separator
    nsSeparator: ":",
  });

export default i18n;
